// src/utils/serviceWorkerUtils.js

import { log, sendCacheDownloadResult } from './bridge';

/**
 * 注册
 */
export async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    const { Workbox } = await import('workbox-window');

    const wb = new Workbox(`/sw.js?baseUrl=${encodeURIComponent(window.publicPath)}`);

    const startTime = +new Date();

    wb.addEventListener('installed', () => {
      sendCacheDownloadResult(true);
      const endTime = +new Date();
      log(`Service Worker 已安装:${endTime}, 耗时:${endTime - startTime}`);
    });

    wb.addEventListener('activated', () => {
      log(`Service Worker 已激活:${+new Date()}`);
    });

    wb.addEventListener('controlling', () => {
      log(`Service Worker 已接管当前客户端:${+new Date()}`);
    });

    wb.addEventListener('waiting', () => {
      log(`Service Worker 正在等待:${+new Date()}`);
    });

    wb.register().then((res) => {
      if (res?.active?.state === 'activated' && !res?.installing) {
        sendCacheDownloadResult(true);
      }
      log(
        `Service Worker 注册成功:${startTime}, state: ${res?.active?.state}, installing: ${res?.installing}, host:${location.host}`,
      );
    });
  } else {
    sendCacheDownloadResult(false);
  }
}

/**
 * 注销serviceWorker
 */
export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
}
